var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.0029 0.00585938C13.4369 0.00585938 0.00588989 13.4369 0.00588989 30.0029C0.00588989 44.9729 10.9739 57.3809 25.3169 59.6399V38.6759H17.6969V30.0029H25.3169V23.3939C25.3169 15.8699 29.7959 11.7209 36.6449 11.7209C39.9269 11.7209 43.3649 12.3059 43.3649 12.3059V19.6829H39.5729C35.8529 19.6829 34.6889 21.9989 34.6889 24.3719V29.9969H43.0019L41.6729 38.6699H34.6889V59.6339C49.0319 57.3869 59.9999 44.9759 59.9999 30.0029C59.9999 13.4369 46.5689 0.00585938 30.0029 0.00585938V0.00585938Z","fill":"#9FD833"}));
}

Facebook.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
